<div class="main_div">
  <div>
    <span class="fs_16">Donor Dashboard</span>
  </div>

  <div class="d-flex justify-content-between">
    <div class="title">Donor Dashboard</div>
    <div
      class="d-flex gap-2 cursor"
      [routerLink]="['/dashboard/donor-crm/donor-analytics']"
    >
      <div class="title c_0054a6 text-decoration-underline">
        View Detail Analysis
      </div>
      <img src="./assets/images/icon/expand_round_blue_icon.svg" />
    </div>
  </div>

  <div class="d-flex gap_32">
    <div class="chart_card">
      <div class="d-flex justify-content-between">
        <div class="title">Total Donors</div>
        <img src="./assets/images/icon/group_icon.svg" />
      </div>

      <div class="value">{{ donorActivity?.total_donors | number }}</div>

      <dx-pie-chart
        id="pie"
        type="doughnut"
        [palette]="['#0054a6', '#ffd602']"
        [dataSource]="[{
        type: 'Total',
        percent: 1,
      }]"
      >
        <dxo-legend
          [visible]="false"
          horizontalAlignment="center"
          verticalAlignment="bottom"
        ></dxo-legend>
        <dxi-series argumentField="type" valueField="percent">
          <dxo-label
            [visible]="true"
            [customizeText]="customizeLabel"
            format=",##0 %"
          >
            <dxo-connector [visible]="true" [width]="1"></dxo-connector>
          </dxo-label>
        </dxi-series>
      </dx-pie-chart>

      <div class="center_center gap_32">
        <div class="center_center">
          <div class="fs_18 fw-bolder">Total</div>
          <div class="fs_18 fw-bolder blue_round">
            {{ donorActivity?.total_donors | number }}
          </div>
        </div>
        <!-- <div class="center_center">
          <div class="fs_18 fw-bolder">Lapsed</div>
          <div class="fs_18 fw-bolder yellow_round">30%</div>
        </div> -->
      </div>
    </div>

    <div class="chart_card">
      <div class="d-flex justify-content-between">
        <div class="title">Total Fund Raised</div>
        <img src="./assets/images/icon/donate_hand_icon.svg" />
      </div>

      <div class="value">৳ {{ donorActivity.total_fund_raised | number }}</div>

      <!-- <dx-chart
        [dataSource]="[
          { month: 'January', progress: 10 },
          { month: 'February', progress: 20 },
          { month: 'March', progress: 35 },
          { month: 'April', progress: 50 },
          { month: 'May', progress: 70 },
          { month: 'June', progress: 90 }
        ]"
        [palette]="['#0054a6']"
      >
        <dxo-legend
          [visible]="false"
          horizontalAlignment="center"
          verticalAlignment="bottom"
        ></dxo-legend>
        <dxi-series
          argumentField="month"
          valueField="progress"
          type="area"
          color="#0054a6"
        >
        </dxi-series>
        <dxo-label><dxo-argument-axis></dxo-argument-axis> </dxo-label>
        <dxo-argument-axis [visible]="false"></dxo-argument-axis>
      </dx-chart> -->

      <dx-pie-chart
        id="pie"
        type="doughnut"
        [palette]="['#0054a6', '#ffd602']"
        [dataSource]="[{
        type: 'NGO Direct Donation',
        value: donorActivity?.direct_donation_amount,
      },
      {
        type: 'Campaign Donation',
        value: donorActivity?.campaign_donation_amount,
      }]"
      >
        <!-- <dxo-size [height]="450" [width]="441"></dxo-size> -->
        <dxo-legend
          [visible]="true"
          horizontalAlignment="center"
          verticalAlignment="bottom"
        ></dxo-legend>
        <dxi-series argumentField="type" valueField="value">
          <dxo-label
            [visible]="true"
            [customizeText]="customizeLabel"
            format="৳ ,##0"
          >
            <dxo-connector [visible]="true" [width]="1"></dxo-connector>
          </dxo-label>
        </dxi-series>
      </dx-pie-chart>

      <!-- <div>
        <div class="center_center">
          <div class="fs_18 fw-bolder blue_round">+3.21%</div>
          <div class="fs_18 fw-bolder">Monthly growth</div>
        </div>
      </div> -->
    </div>
  </div>

  <div class="d-flex justify-content-between">
    <div class="title">Recent Donor Activity</div>
    <div class="d-flex gap-2 cursor" (click)="showDonorActivityPopupOpen()">
      <div class="title c_0054a6 text-decoration-underline">
        View All Donor Activity
      </div>
      <img src="./assets/images/icon/expand_round_blue_icon.svg" />
    </div>
  </div>

  <!-- <div class="filter_div">
    <div class="center_center gap-2">
      <div class="fs_18 mr-2">By Date Range:</div>
      <dx-date-range-box
            class="time_line"
            [startDate]="startDate"
            [endDate]="endDate"
            labelMode="floating"
            [min]="oneYearAgo"
            [max]="today"
            displayFormat="dd MMM, yyyy"
            (onValueChanged)="updateDateRange($event)"
          ></dx-date-range-box>
    </div>

    <div class="center_center justify-content-between gap-3">
      <div class="center_center gap-2">
        <div class="fs_18">By Campaign:</div>
        <dx-select-box class="inputField"></dx-select-box>
      </div>
      <div class="center_center gap-2">
        <div class="fs_18">By Status:</div>
        <dx-select-box class="inputField"></dx-select-box>
      </div>
    </div>
  </div> -->

  <div>
    <dx-data-grid
      class="donor_list_data_grid"
      [dataSource]="donorActivity.recent_donations"
      [showBorders]="false"
      [showColumnLines]="false"
      [showRowLines]="false"
      [allowColumnResizing]="true"
      columnResizingMode="widget"
      [focusedRowEnabled]="false"
      [rowAlternationEnabled]="false"
      rowTemplate="rowDonationList"
      [wordWrapEnabled]="true"
      [columnAutoWidth]="true"
    >
      <dxo-paging [pageSize]="10" [pageIndex]="0"> </dxo-paging>
      <dxo-pager
        *ngIf="allFundraisers?.length > 10"
        [visible]="true"
        [showPageSizeSelector]="false"
        [allowedPageSizes]="[10]"
        [showInfo]="false"
        [showNavigationButtons]="true"
      >
      </dxo-pager>
      <dxo-sorting mode="none"> </dxo-sorting>
      <dxi-column
        caption="Donor Name"
        dataField="donorName"
        alignment="left"
        [width]="'20%'"
      ></dxi-column>
      @if(isShohayAdmin){
      <dxi-column
        caption="Transaction Id"
        dataField="transaction_id"
        alignment="center"
      >
      </dxi-column>
      }
      <dxi-column
        caption="Date & Time"
        dataField="donation_day"
        alignment="center"
        [width]="'20%'"
      >
      </dxi-column>
      <dxi-column
        caption="Amount"
        dataField="amount"
        alignment="center"
        style="border: none"
        [width]="'20%'"
      >
      </dxi-column>
      <dxi-column
        caption="Campaign"
        dataField="campaign_title"
        alignment="center"
        [width]="'20%'"
      >
      </dxi-column>
      <dxi-column
        caption="Status"
        dataField="status"
        alignment="center"
        style="border: none"
        [width]="'20%'"
      >
      </dxi-column>
      <tbody class="bg-white" *dxTemplate="let row of 'rowDonationList'">
        <tr style="display: contents !important">
          <td>
            <div
              [ngClass]="
                row?.data?.donor_id
                  ? 'donor-profile row_white cursor'
                  : 'donor-profile row_white'
              "
              (click)="
                row?.data?.donor_id ? navigateToProfile(row?.data) : null
              "
            >
              <div class="profile-avatar">
                <img
                  class="profile_img"
                  loading="lazy"
                  [src]="
                    row?.data?.profile_img ||
                    './assets/images/round_profile.png'
                  "
                  alt=""
                />
              </div>
              <div class="profile-details">
                <div class="donor-name fs_18 c_0054a6 cursor">
                  {{ row?.data?.name }}
                </div>
                <div *ngIf="isShohayAdmin" class="donor-email fs_18 text-start">
                  {{ row?.data?.phone }}
                </div>
              </div>
            </div>
          </td>
          @if(isShohayAdmin){
          <td>
            <div class="profile-details">
              <div
                (click)="viewPaymentReceipt(row?.data?.payment_receipt)"
                class="donor-email cursor text-decoration-underline"
              >
                {{ row?.data?.payment_receipt ? "Donation Receipt" : "N/A" }}
              </div>
              <div
                class="donor-name c_0054a6 cursor text-decoration-underline"
                (click)="showReceiptPopup(row?.data)"
              >
                {{ row?.data?.transaction_id || "N/A" }}
              </div>
            </div>
          </td>
          }
          <td>
            <div class="profile-details">
              <div class="donor-name">
                {{ row?.data?.donation_day | date : "dd MMM yyyy" }}
              </div>
              <div class="donor-email">
                {{ row?.data?.created_at | date : "hh:mm a" }}
              </div>
            </div>
          </td>
          <td>
            <div class="donor-name">
              ৳ {{ (row?.data?.amount | number) || 0 }}
            </div>
          </td>
          <td>
            <div class="donor-name c_0054a6">
              {{
                row?.data?.is_direct_donation
                  ? "Direct Donation"
                  : row?.data?.campaign_title
              }}
            </div>
          </td>
          <td>
            <div
              class="donor-name"
              [ngStyle]="{
                color: row?.data?.status === 'PLEDGED' ? '#D92D20' : '#0054a6'
              }"
            >
              ● {{ row?.data?.status }}
            </div>
          </td>
        </tr>
      </tbody>
    </dx-data-grid>
  </div>

  <div
    class="d-flex justify-content-between"
    *ngIf="donorActivity?.top_donors?.length > 0"
  >
    <div class="title">Donor Recognition</div>
    <div class="d-flex gap-2 cursor">
      <div
        class="view_all c_0054a6 text-decoration-underline"
        (click)="donorRecognition()"
      >
        View All
      </div>
    </div>
  </div>

  <div class="supporters_div">
    <div
      *ngFor="let card of donorActivity?.top_donors; let i = index"
      class="supporters_card"
    >
      <div>
        @if(i == 0){
        <img src="./assets/images/icon/trophy_00.svg" />
        }@else if(i==1){
        <img src="./assets/images/icon/trophy_1.svg" />
        }@else{
        <img src="./assets/images/icon/trophy_2.svg" />
        }
      </div>
      <div class="d-flex flex-column gap-2 w-100">
        <div class="d-flex justify-content-between">
          <div>
            <img
              class="profile"
              [src]="
                card?.profile_img?.url
                  ? card?.profile_img?.url
                  : './assets/images/icon/profile_icon_gray.png'
              "
            />
          </div>
          <div>
            <img
              (click)="navigateToProfile(card)"
              class="cursor"
              src="./assets/images/icon/expand_icon_blue.svg"
            />
          </div>
        </div>
        <div class="title">{{ card?.name }}</div>
        <div>
          <span class="fs_16 fw-bolder">Total Donated : </span
          ><span class="fs_16 c_686868"
            >৳ {{ card?.total_amount | number }}</span
          >
        </div>
        <div>
          <span class="fs_16 fw-bolder">All Campaigns : </span
          ><span class="fs_16 c_0054a6 fw-bolder">{{
            card?.campaign_ids?.length
          }}</span>
        </div>
      </div>
    </div>
  </div>

  @if(isShohayAdmin){
  <div class="supporters_div">
    <div class="card">
      <div class="d-flex justify-content-between">
        <img src="./assets/images/icon/love_round_icon.svg" />
        <button class="blue-button-sm">Create Email</button>
      </div>
      <div class="fs_18 fw-bolder c_0054a6">Send Thank You Emails</div>
      <div class="fs_16 c_808080">Show appreciation to recent donors.</div>
    </div>

    <div class="card">
      <div class="d-flex justify-content-between">
        <img src="./assets/images/icon/profile_curcular_icon.svg" />
        <button class="blue-button-sm">Send Campaign</button>
      </div>
      <div class="fs_18 fw-bolder c_0054a6">Send Thank You Emails</div>
      <div class="fs_16 c_808080">
        Show appreciation to who recently donated on your campaigns
      </div>
    </div>

    <div class="card">
      <div class="d-flex justify-content-between">
        <img src="./assets/images/icon/mike_round_icon.svg" />
        <button class="blue-button-sm">View Emails</button>
      </div>
      <div class="fs_18 fw-bolder c_0054a6">Promote Recurring Donations</div>
      <div class="fs_16 c_808080">
        Promote Recurring Donations Encourage one-time donors to OPT for
        recurring.
      </div>
    </div>
  </div>
  }
</div>

<dx-popup
  class="donor_activity"
  [(visible)]="showDonorActivityPopup"
  [width]="'80vw'"
  [height]="'95vh'"
  [showTitle]="true"
  [showCloseButton]="true"
  [dragEnabled]="false"
  [resizeEnabled]="false"
  position="center"
  [enableBodyScroll]="false"
  [hideOnOutsideClick]="false"
>
  <div class="h-100">
    <div class="w-100 text-center">
      <h1 class="fw-bolder">Donor Activity</h1>
    </div>

    <div class="filter_div_popup py-0 h-70">
      <div class="center_center gap-2">
        <div class="fs_18 mr-2">By Date Range:</div>
        <dx-date-range-box
          class="time_line"
          [startDate]="startDate"
          [endDate]="endDate"
          labelMode="floating"
          [min]="oneYearAgo"
          [max]="today"
          displayFormat="dd MMM, yyyy"
          (onValueChanged)="updateDateRange($event)"
        >
          <dx-validator validationGroup="validationGroup">
            <dxi-validation-rule
              type="required"
              message="Start & End date is required"
            ></dxi-validation-rule>
            <dxi-validation-rule
              type="custom"
              message="Start & End dates must be at most 5 months apart"
              [validationCallback]="validateDateRange"
            ></dxi-validation-rule>
          </dx-validator>
        </dx-date-range-box>
      </div>

      <div class="center_center justify-content-between gap-3">
        <!-- <div class="center_center gap-2">
          <div class="fs_18">By Campaign:</div>
          <dx-select-box class="inputField"></dx-select-box>
        </div> -->
        <div class="center_center gap-2">
          <div class="fs_18">By Status:</div>
          <dx-select-box
            [dataSource]="[
              { status: 'ALL' },
              { status: 'DONATED' },
              { status: 'PLEDGED' }
            ]"
            displayExpr="status"
            valueExpr="status"
            [(value)]="selectedStatus"
            placeholder="Select Status"
            (onValueChanged)="onStatusChanged($event)"
            class="chart-select"
          ></dx-select-box>
        </div>
      </div>
    </div>

    <div class="data_grid">
      <dx-data-grid
        class="donor_list_data_grid"
        [dataSource]="recentActivity"
        [showBorders]="false"
        [showColumnLines]="false"
        [showRowLines]="false"
        [allowColumnResizing]="true"
        columnResizingMode="widget"
        [focusedRowEnabled]="false"
        [rowAlternationEnabled]="false"
        rowTemplate="rowDonationList"
        [wordWrapEnabled]="true"
        [columnAutoWidth]="true"
      >
        <dxo-paging [pageSize]="7" [pageIndex]="0"> </dxo-paging>
        <dxo-sorting mode="none"> </dxo-sorting>
        <dxo-pager
          *ngIf="allFundraisers?.length > 7"
          [visible]="true"
          [showPageSizeSelector]="false"
          [allowedPageSizes]="[7]"
          [showInfo]="false"
          [showNavigationButtons]="true"
        >
        </dxo-pager>
        <dxi-column
          caption="Donor Name"
          dataField="donorName"
          alignment="left"
        ></dxi-column>
        <!-- <dxi-column
          caption="Transaction Id"
          dataField="transactionId"
          alignment="center"
        >
        </dxi-column> -->
        <dxi-column caption="Date & Time" dataField="date" alignment="center">
        </dxi-column>
        <dxi-column
          caption="Amount"
          dataField="amount"
          alignment="center"
          style="border: none"
        >
        </dxi-column>
        <dxi-column caption="Campaign" dataField="campaign" alignment="center">
        </dxi-column>
        <dxi-column
          caption="Status"
          dataField="status"
          alignment="center"
          style="border: none"
        >
        </dxi-column>

        <tbody class="bg-white" *dxTemplate="let row of 'rowDonationList'">
          <tr style="display: contents !important">
            <td>
              <div
                class="donor-profile row_white"
                (click)="
                  row?.data?.donor_id ? navigateToProfile(row?.data) : null
                "
              >
                <div class="profile-avatar">
                  <img
                    class="profile_img"
                    loading="lazy"
                    [src]="
                      row?.data?.profile_img ||
                      './assets/images/round_profile.png'
                    "
                    alt=""
                  />
                </div>
                <div class="profile-details">
                  <div
                    [ngClass]="
                      row?.data?.donor_id
                        ? 'donor-name fs_18 c_0054a6 cursor'
                        : 'donor-name fs_18 c_0054a6'
                    "
                  >
                    {{ row?.data?.name }}
                  </div>
                  <!-- <div class="donor-email fs_18 text-start">
                    {{ row?.data?.phoneNumber }}
                  </div> -->
                </div>
              </div>
            </td>
            <!-- <td>
              <div class="profile-details">
                <div class="donor-email">{{ row?.data?.paymentMethod }}</div>
                <div
                  class="donor-name c_0054a6 cursor text-decoration-underline"
                  (click)="showReceiptPopup(row?.data)"
                >
                  {{ row?.data?.transactionId }}
                </div>
              </div>
            </td> -->
            <td>
              <div class="profile-details">
                <div class="donor-name">
                  {{ row?.data?.created_at | date : "dd MMM yyyy" }}
                </div>
                <div class="donor-email">
                  {{ row?.data?.created_at | date : "hh:mm a" }}
                </div>
              </div>
            </td>
            <td>
              <div class="donor-name">
                ৳ {{ (row?.data?.amount | number) || 0 }}
              </div>
            </td>
            <td>
              <div class="donor-name c_0054a6">
                {{
                  row?.data?.is_direct_donation
                    ? "Direct Donation"
                    : row?.data?.campaign_title
                }}
              </div>
            </td>
            <td>
              <div
                class="donor-name"
                [ngStyle]="{
                  color:
                    row?.data?.status === 'PENDING'
                      ? '#FFDE21'
                      : row?.data?.status === 'REJECTED'
                      ? '#D92D20'
                      : '#0054a6'
                }"
              >
                ● {{ row?.data?.status }}
              </div>
            </td>
          </tr>
        </tbody>
      </dx-data-grid>
    </div>
  </div>
</dx-popup>

<dx-popup
  class="donor_activity"
  [(visible)]="DonorRecognetitonPopup"
  [width]="'80vw'"
  [height]="'80vh'"
  [maxHeight]="'90vh'"
  [showTitle]="true"
  [showCloseButton]="true"
  [dragEnabled]="false"
  [resizeEnabled]="false"
  position="center"
  [enableBodyScroll]="false"
  [hideOnOutsideClick]="false"
>
  <div class="h-100">
    <div
      class="w-100 text-center"
      style="margin-bottom: 64px; margin-top: 16px"
    >
      <h1 class="fw-bolder">Top 10 Donors</h1>
    </div>

    <div class="data_grid">
      <dx-data-grid
        class="donor_list_data_grid"
        [dataSource]="top10Donors"
        [showBorders]="false"
        [showColumnLines]="false"
        [showRowLines]="false"
        [allowColumnResizing]="true"
        columnResizingMode="widget"
        [focusedRowEnabled]="false"
        [rowAlternationEnabled]="false"
        rowTemplate="rowDonationList"
        [wordWrapEnabled]="true"
        [columnAutoWidth]="true"
      >
        <dxi-column
          caption="Donor Name"
          dataField="name"
          [width]="'40%'"
        ></dxi-column>
        <dxi-column
          caption="Contributions"
          dataField="total_amount"
          [width]="'30%'"
        >
        </dxi-column>
        <dxi-column
          caption="Campaigns Participate"
          dataField="Participate"
          [width]="'30%'"
        >
        </dxi-column>

        <tbody class="bg-white" *dxTemplate="let row of 'rowDonationList'">
          <tr class="custom_row" style="height: 70px">
            <td>
              <div
                [ngClass]="row?.data?.donor_id ? 'combine cursor' : 'combine'"
                (click)="
                  row?.data?.donor_id ? navigateToProfile(row?.data) : null
                "
              >
                <div class="employee_rank">
                  <img
                    *ngIf="row?.rowIndex < 3"
                    loading="lazy"
                    [src]="
                      './assets/images/icon/trophy_' + row?.rowIndex + '.svg'
                    "
                    alt="rank"
                  />
                  <span style="margin-left: 12px" *ngIf="row?.rowIndex > 2">{{
                    row?.rowIndex + 1
                  }}</span>
                </div>
                <div class="employee_profile">
                  <img
                    loading="lazy"
                    [src]="
                      row?.data?.profile_img
                        ? row?.data?.profile_img?.url
                        : './assets/images/round_profile.png'
                    "
                    alt="PROFILE"
                  />
                </div>
                <div class="normal_data" style="padding-top: 5px">
                  {{ row?.data?.name }}
                </div>
              </div>
            </td>
            <td>
              <div class="normal_data">{{ row?.data?.total_amount }}</div>
            </td>
            <td>
              <div class="combine">
                <div
                  class="employee_rank multiple_icon"
                  style="margin-right: 8px"
                >
                  <img
                    loading="lazy"
                    src="./assets/images/icon/person-logo-icon.svg"
                    alt="rank"
                  />
                </div>
                <span class="normal_data" style="color: #0054a6">
                  ({{ row.data?.campaign_ids?.length | number }})
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </dx-data-grid>
    </div>
  </div>
</dx-popup>

<app-receipts [receipt]="receiptObject"></app-receipts>
